var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-ship"},[_c('div',{staticClass:"button delete-button",on:{"click":_vm.deleteShip}},[_vm._v("Delete "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.shipDisplay)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca9b641","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modalCommon/DeleteShip.vue
// module id = null
// module chunks = 